
import subscriptionConstants from '@/constants/subscription.constants';
import FAQList from '@/components/shared/FAQList.vue';

const { subscribeProductKeys, subscriptionPlans } = subscriptionConstants;

export default {
    name: 'MarketAnalysisFAQ',

    components: {
        FAQList,
    },

    computed: {
        infoIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/info-filled-dark.svg') :
                require('@/assets/icons/info-filled-light.svg');
        },
        isLoggedIn() {
            return !!this.$store.state.account.user;
        },
        isSubscribedFinAgent() {
            return this.isLoggedIn && this.$store.state.account.subscribedProductIds?.includes(subscribeProductKeys.finAgent);
        },
        isFreePlan() {
            return this.isLoggedIn && !this.isSubscribedFinAgent;
        },
        isReachFreePlanLimit() {
            return this.$store.state.finAgent.isReachFreePlanLimit;
        },
        finAgentLink() {
            if (this.isSubscribedFinAgent || (this.isFreePlan && !this.isReachFreePlanLimit)) {
                return this.$getTranslatedRoutePath('/fin-agent/');
            }

            if (this.isFreePlan && this.isReachFreePlanLimit) {
                return {
                    name: this.$getTranslatedRouteName('subscription'),
                    params: { plan: subscriptionPlans.ai }
                };
            }

            return this.$getTranslatedRoutePath('/fin-agent/');
        }
    },
}
